import { Modal, ModalOverlay, useToast } from '@apexinternal/ui-components'
import { Box, Icon, Link, useDisclosure } from '@chakra-ui/react'
import React, { useState } from 'react'
import { FaRegEdit } from 'react-icons/fa'
import { restrictAccount, SUCCESS_IN_24_HOURS } from '../../../../actions'
import { useToastErrorHandler } from '../../../../hooks'
import { AccountStatus } from '../../../../types'
import ConfirmModalContent from './ConfirmModalContent'
import EditModalContent from './EditModalContent'

interface RestrictAccountModalProps {
  accountNumber: string
}

const RestrictAccountModal = ({ accountNumber }: RestrictAccountModalProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [isConfirmationView, setConfirmationView] = useState(false)
  const [accountStatus, setAccountStatus] = useState(AccountStatus.Active)
  const [reason, setReason] = useState('')
  const onError = useToastErrorHandler()
  const toast = useToast()

  const reset = () => {
    setAccountStatus(AccountStatus.Active)
    setReason('')
    setConfirmationView(false)
  }

  const closeModal = () => {
    reset()
    onClose()
  }

  const confirmRestrictAccount = () => {
    restrictAccount(
      onError,
      () => {
        toast({
          title: 'Success!',
          description: SUCCESS_IN_24_HOURS,
          status: 'success',
          isClosable: true,
        })
        closeModal()
      },
      accountNumber,
      accountStatus,
      reason
    )
  }

  return (
    <Box>
      <Link color="blue.500" onClick={onOpen}>
        <Icon as={FaRegEdit} marginRight="0.357rem" />
        Change Status
      </Link>
      <Modal isCentered isOpen={isOpen} onClose={() => {}} size="xl">
        <ModalOverlay />
        {isConfirmationView ? (
          <ConfirmModalContent
            accountStatus={accountStatus}
            reason={reason}
            onBack={() => setConfirmationView(false)}
            onClose={closeModal}
            onConfirm={confirmRestrictAccount}
          />
        ) : (
          <EditModalContent
            accountStatus={accountStatus}
            reason={reason}
            setAccountStatus={setAccountStatus}
            setReason={setReason}
            onClose={closeModal}
            onConfirm={() => setConfirmationView(true)}
          />
        )}
      </Modal>
    </Box>
  )
}

export default RestrictAccountModal
